/* Non-critical fonts */
document.addEventListener("DOMContentLoaded",function(){var style=document.createElement("style");style.textContent=`@font-face{font-family:"Proxima Nova";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNova-Light.woff2")format("woff2"),url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNova-Light.woff")format("woff");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Proxima Nova";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNova-Semibold.woff2")format("woff2"),url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNova-Semibold.woff")format("woff");font-weight:600;font-style:normal;font-display:swap;}@font-face{font-family:"Albra";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/AlbraTextRegular.woff2")format("woff2"),url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/AlbraTextRegular.woff")format("woff");font-weight:normal;font-style:normal;font-display:swap;}@font-face{font-family:"Albra";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/AlbraTextLight.woff2")format("woff2"),url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/AlbraTextLight.woff")format("woff");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Proxima-Nova-300";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNovaA-Light.woff2");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Proxima-Nova-600";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/ProximaNovaS-Semibold.woff2");font-weight:600;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/Figtree-Light.ttf");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/Figtree-Regular.ttf");font-weight:400;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/Figtree-Medium.ttf");font-weight:500;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/drmtlgy_medium/Figtree-Bold.ttf");font-weight:700;font-style:normal;font-display:swap;}`;document.head.appendChild(style);});
/* Start Section drmlec_zive_28feb_wwai_before_after_2_bWT7TB */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .swiper',{loop:false,slidesPerView:1,spaceBetween:36,grabCursor:false,centeredSlides:1,initialSlide:0,roundLengths:true,speed:1500,navigation:{nextEl:'.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .next',prevEl:'.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .prev',clickable:true},pagination:{el:".dots",clickable:true},breakpoints:{500:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0},768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0}},on:{init:function(){toggleNavigationButtons(this);},slideChange:function(){toggleNavigationButtons(this);},resize:function(){toggleNavigationButtons(this);}}});function toggleNavigationButtons(swiperInstance){const nextButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .next');const prevButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_before_after_2_bWT7TB .prev');const totalSlides=swiperInstance.slides.length;const slidesPerView=swiperInstance.params.slidesPerView;if(totalSlides<=slidesPerView){nextButton.style.display='none';prevButton.style.display='none';}else{nextButton.style.display=null;prevButton.style.display=null;}}});
/* End Section drmlec_zive_28feb_wwai_before_after_2_bWT7TB */
/* Start Section product_section_drm_v_2_nmBYVF */
document.addEventListener('DOMContentLoaded',function(){function closeModal(){const togglBtn=document.querySelector('[data-toggl="model"]');if(!togglBtn){console.warn("No toggle button found with data-toggl='model'");return;}
const modelContainer=document.querySelector(`[data-id="${togglBtn.dataset.toggl}"]`);if(!modelContainer){console.warn(`No modal container found with data-id="${togglBtn.dataset.toggl}"`);return;}
modelContainer.style.display='none';console.log("Modal closed.");}
document.querySelectorAll('[data-modal-link-update]').forEach(link=>{link.addEventListener('click',function(event){event.preventDefault();const variantName=this.getAttribute('data-shade-modal-variant');if(variantName){console.log(`Intercepted click:Variant Name->${variantName}`);const event=new CustomEvent('variant_changed',{detail:{variantName}});document.dispatchEvent(event);}else{console.warn("No data-variant attribute found on clicked link.");}
closeModal();});});});function manageQtyBtn(event){event.preventDefault();let currentTarget=event.currentTarget;let action=currentTarget.dataset.for||'increase';let qtyContainer=currentTarget.closest('[data-qty-container]');let qtyInput=qtyContainer.querySelector('[data-qty-input]');let currentQty=parseInt(qtyInput.value)||1;let finalQty=currentQty;let decreaseQtyBtn=qtyContainer.querySelector('[data-for="decrease"]');if(action==='decrease'&&currentQty>1){finalQty=currentQty-1;}else if(action==='increase'){finalQty=currentQty+1;}
qtyInput.value=finalQty;if(finalQty<=1){decreaseQtyBtn.classList.add('disabled');}else{decreaseQtyBtn.classList.remove('disabled');}}
const qtyBtns=document.querySelectorAll('[data-qty-btn]');qtyBtns.forEach(qtyBtn=>{qtyBtn.addEventListener('click',manageQtyBtn);});const inputBtns=document.querySelectorAll('[data-input-change]');inputBtns.forEach(inputBtn=>{inputBtn.addEventListener('change',()=>{const closestElement=inputBtn.closest('[data-closest-input]');document.querySelectorAll('[data-closest-input]').forEach(closest=>{closest.classList.remove('active-input');});if(closestElement){if(inputBtn.checked){closestElement.classList.add('active-input');}}});});document.addEventListener('DOMContentLoaded',function(){let thumbnailSlider=new Swiper('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail',{direction:'horizontal',slidesPerView:4,spaceBetween:10,grabCursor:true,loop:false,slideToClickedSlide:true,watchSlidesVisibility:true,watchSlidesProgress:true,breakpoints:{768:{slidesPerView:5,direction:'vertical',spaceBetween:13,},},});let carouselSlider=new Swiper('.section-template--product_section_drm_v_2_nmBYVF .product-carousel',{shortSwipes:true,resizeObserver:true,observer:true,observeParents:true,loop:false,slidesPerView:1,grabCursor:true,pagination:{el:'.section-template--product_section_drm_v_2_nmBYVF .product-carousel .swiper-pagination',clickable:true,},thumbs:{swiper:thumbnailSlider,},on:{init:function(){const carouselWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-carousel');const thumbnailWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail');if(carouselWrapper&&thumbnailWrapper){thumbnailWrapper.style.maxHeight=`${carouselWrapper.offsetHeight}px`;}},resize:function(){const carouselWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-carousel');const thumbnailWrapper=document.querySelector('.section-template--product_section_drm_v_2_nmBYVF .product-thumbnail');if(carouselWrapper&&thumbnailWrapper){thumbnailWrapper.style.maxHeight=`${carouselWrapper.offsetHeight}px`;}},}});document.addEventListener('swipetoSlide',function(event){let index=event.detail.index;if(carouselSlider&&typeof index==='number'){carouselSlider.slideTo(index);}});})
document.addEventListener('DOMContentLoaded',function(){const togglBtn=document.querySelector('[data-toggl="model"]');const modelContainer=document.querySelector(`[data-id="${togglBtn.dataset.toggl}"]`);cosst=modleOverlay=modelContainer.querySelector('.overlay');cosst=modleClose=modelContainer.querySelector('.model_close-btn');modleOverlay?.addEventListener('click',(e)=>{modelContainer.style.display='none';});modleClose?.addEventListener('click',(e)=>{modelContainer.style.display='none';});togglBtn?.addEventListener('click',(e)=>{modelContainer.style.display='block';});});
/* End Section product_section_drm_v_2_nmBYVF */
/* Start Section drmlec_zive_28feb_wwai_review_carousel_LxUQyg */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .swiper',{loop:false,slidesPerView:1,spaceBetween:36,grabCursor:false,centeredSlides:1,initialSlide:0,roundLengths:true,speed:1500,navigation:{nextEl:'.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .next',prevEl:'.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .prev',clickable:true},pagination:{el:".dots",clickable:true},breakpoints:{500:{slidesPerView:2,centeredSlides:false,loop:false,initialSlide:0},768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0}},on:{init:function(){toggleNavigationButtons(this);},slideChange:function(){toggleNavigationButtons(this);},resize:function(){toggleNavigationButtons(this);}}});function toggleNavigationButtons(swiperInstance){const nextButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .next');const prevButton=document.querySelector('.section-template--drmlec_zive_28feb_wwai_review_carousel_LxUQyg .prev');const totalSlides=swiperInstance.slides.length;const slidesPerView=swiperInstance.params.slidesPerView;if(totalSlides<=slidesPerView){nextButton.style.display='none';prevButton.style.display='none';}else{nextButton.style.display=null;prevButton.style.display=null;}}});
/* End Section drmlec_zive_28feb_wwai_review_carousel_LxUQyg */
/* Start Section video_section_drm_v_2_PtM77C */
document.addEventListener('DOMContentLoaded',function(){var Swipes;function initSwiper(){if(window.innerWidth>768){if(!Swipes){Swipes=new Swiper('.section-template--video_section_drm_v_2_PtM77C .swiper',{loop:false,slidesPerView:1,spaceBetween:15,grabCursor:false,centeredSlides:true,initialSlide:0,roundLengths:true,speed:1500,breakpoints:{768:{slidesPerView:3,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:30},1199:{slidesPerView:4,centeredSlides:false,loop:false,initialSlide:0,spaceBetween:30}}});Swipes.on('slideChange',function(){document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(video=>{video.classList.remove('played');video.querySelectorAll('video').forEach(ele=>{ele.pause();})});});}}else{if(Swipes){Swipes.destroy(true,true);Swipes=null;}}}
initSwiper();window.addEventListener('resize',function(){initSwiper();});});document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(video=>{video.addEventListener('click',function(){document.querySelectorAll('.section-template--video_section_drm_v_2_PtM77C video-player').forEach(ele=>{if(video!=ele){ele.classList.remove('played');ele.querySelectorAll('video').forEach(ele=>{ele.pause();});}});});});
/* End Section video_section_drm_v_2_PtM77C */

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});

// class VideoPlayer extends HTMLElement {
//   constructor() {
//     super();
//     this.videos = this.querySelectorAll('video');
//     this.videoWeb = this.videos[0];
//     this.videoMob = this.videos[1];
//     this.playBtn = this.querySelector('.play-btn');
//     this.soundBtn = this.querySelector('.mute-btn');
//     this.disableClick = this.dataset.click;
//     if (this.disableClick) {
//       this.initEventListeners();
//     }
//   }

//   initEventListeners() {
//     this.videos.forEach(video => {
//       video.addEventListener('click', () => this.togglePlay(video));
//       video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
//     });

//     if (this.playBtn) {
//       this.playBtn.addEventListener('click', () => this.handlePlayButton());
//     }

//     if (this.soundBtn) {
//       this.soundBtn.addEventListener('click', () => this.toggleMute());
//     }

//     window.addEventListener('resize', () => this.handleResize());
//   }

//   togglePlay(video) {
//     if (video.paused) {
//       this.playVideo(video);
//     } else {
//       this.pauseVideo(video);
//     }
//   }

//   playVideo(video) {
//     this.videos.forEach(otherVideo => {
//       if (otherVideo !== video) otherVideo.pause();
//     });
//     video.play();
//     this.classList.add('played');
//   }

//   pauseVideo(video) {
//     video.pause();
//     this.classList.remove('played');
//   }

//   handlePlayButton() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) this.togglePlay(targetVideo);
//   }

//   toggleMute() {
//     const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
//     if (targetVideo) {
//       targetVideo.muted = !targetVideo.muted;
//       this.soundBtn.classList.toggle('active', targetVideo.muted);
//     }
//   }

//   handleResize() {
//     if (!this.videoMob) return;

//     const isMobile = window.innerWidth < 749;
//     const targetVideo = isMobile ? this.videoMob : this.videoWeb;

//     this.videos.forEach(video => video.pause());
//     targetVideo.play();
//     targetVideo.pause(); // Ensure the video is ready for user interaction
//   }

//   handleVideoEnded(video) {
//     // Check if the video is not set to loop
//     if (!video.loop) {
//       this.classList.remove('played');
//     }
//   }
// }

// customElements.define('video-player', VideoPlayer);

(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video)); // Listen for the `ended` event
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) otherVideo.pause();
        });
        video.play();
        this.classList.add('played');
      }

      pauseVideo(video) {
        video.pause();
        this.classList.remove('played');
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => video.pause());
        targetVideo.play();
        targetVideo.pause(); // Ensure the video is ready for user interaction
      }

      handleVideoEnded(video) {
        // Check if the video is not set to loop
        if (!video.loop) {
          this.classList.remove('played');
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();

// Example: Show the logs.
document.customProductEventLoggingEnabled = false;

function getVariantDetails(variantName) {
    // Check if window.PRODUCT_DATA exists
    if (!window.PRODUCT_DATA || !window.PRODUCT_DATA[variantName]) {
        console.warn(`No product data found for variant: ${variantName}`);
        return null;
    }

    const product = window.PRODUCT_DATA[variantName];

    // Ensure the product has only one variant
    if (!product.variants || product.variants.length !== 1) {
        console.warn(`Product for ${variantName} has multiple or no variants.`);
        return null;
    }

    // Extract variant details
    const variant = product.variants[0];

    // Default price logic
    let price = variant.price;
    let compare_at_price = variant.compare_at_price || null;

    // Apply discount logic only if window.discount_percent is defined and > 0
    if (window.discount_percent > 0) {
        compare_at_price = Math.max(variant.price, variant.compare_at_price || 0);
        price = compare_at_price - (compare_at_price * window.discount_percent / 100);
    }

    return {
        variant_id: variant.id,
        variant_title: product.title,
        price: price,
        compare_at_price: compare_at_price
    };
}


// function getVariantDetails(variantName) {
//   // Check if window.PRODUCT_DATA exists
//   if (!window.PRODUCT_DATA || !window.PRODUCT_DATA[variantName]) {
//       console.warn(`No product data found for variant: ${variantName}`);
//       return null;
//   }
  
//   const product = window.PRODUCT_DATA[variantName];
  
//   // Ensure the product has only one variant
//   if (!product.variants || product.variants.length !== 1) {
//       console.warn(`Product for ${variantName} has multiple or no variants.`);
//       return null;
//   }
  
//   // Extract variant details
//   const variant = product.variants[0];
  
//   return {
//       variant_id: variant.id,
//       variant_title: product.title,
//       price: variant.price,
//       compare_at_price: variant.compare_at_price || null
//   };
// }



class ProductFormVariantWithListener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('product_variant_changed', (event) => {
      const { variant_id } = event.detail;
      
      document.customProductEventLoggingEnabled && console.log(`product_variant_changed event received: New Variant ID ->`, variant_id);

      // Select the form inside this component
      const form = this.querySelector('form');

      if (form) {
        // Find the input inside the form with name="id"
        const variantInput = form.querySelector('input[name="id"]');

        if (variantInput) {
          variantInput.value = variant_id;
          document.customProductEventLoggingEnabled && console.log(`Updated hidden input with new variant ID: ${variant_id}`);
        } else {
          console.warn('No hidden input with name="id" found for storing the variant ID.');
        }
      } else {
        console.warn('No form found inside <product-variant-listener>');
      }
    });
  }
}

// Define the custom element
customElements.define('product-form-variant-with-listener', ProductFormVariantWithListener);


class ProductPriceWithListener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('product_price_changed', (event) => {
      const { compare_at_price, price } = event.detail;

      document.customProductEventLoggingEnabled && console.log(`product_price_changed event received`);
      document.customProductEventLoggingEnabled && console.log(`New Compare at Price: ${compare_at_price}, New Price: ${price}`);

      // Select price elements inside this component
      const compareAtPriceElement = this.querySelector('[data-product-compare-at-price]');
      const priceElement = this.querySelector('[data-product-price]');

      // Update price
      if (priceElement) {
        priceElement.textContent = this.formatMoney(price);
      }

      // Show compare_at_price only if it's greater than price
      if (compareAtPriceElement) {
        if (compare_at_price && compare_at_price > price) {
          compareAtPriceElement.textContent = this.formatMoney(compare_at_price);
          compareAtPriceElement.style.display = 'block';
        } else {
          compareAtPriceElement.style.display = 'none';
        }
      }

      document.customProductEventLoggingEnabled && console.log(`Price updated successfully`);
    });
  }

  formatMoney(amount) {
    return `$${(amount / 100).toFixed(2)}`; // Example: Converts 4400 -> "$44.00"
  }
}

// Define the custom element
customElements.define('product-price-with-listener', ProductPriceWithListener);

class ProductTitleWithListener extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener('product_title_changed', (event) => {
      const { newTitle } = event.detail;
      document.customProductEventLoggingEnabled && console.log(`product_title_changed event received, New Title:`, newTitle);
      
      const titleElement = this.querySelector('p');
      if (titleElement) {
        titleElement.textContent = newTitle;
        document.customProductEventLoggingEnabled && console.log(`Product title updated successfully:`, newTitle);
      } else {
        console.warn(`No <p> found inside <product-title>`);
      }
    });
  }
}

// Define the custom element
customElements.define('product-title-with-listener', ProductTitleWithListener);

class ProductVariantSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    
    // Select all variant radio inside this component.
    this.variantRadioElements = this.querySelectorAll('input[type="radio"]');

    this.variantRadioElements.forEach(element => {
      document.customProductEventLoggingEnabled && console.log("Adding event listener to:", element);

      element.addEventListener('change', (event) => {
        document.customProductEventLoggingEnabled && console.log("Variant changed:", element);

        const variantName = element.getAttribute('value'); // Get variant name
        document.customProductEventLoggingEnabled && console.log("Changed variant is:", variantName);
        this.handleVariantChanged(variantName);
      });
    });

    
    // Mark the document as having the variant change listener
    document.hasVariantChangeListener = false;
    
    // Listen for external variant change events
    document.addEventListener('variant_changed', (event) => {
        document.customProductEventLoggingEnabled && console.log("variant_changed listener set.");
        const { variantName } = event.detail;
        document.customProductEventLoggingEnabled && console.log("variant_changed event received for:", variantName);
    
        // Find the corresponding radio input
        const radioInput = document.querySelector(`input[type="radio"][value="${variantName}"]`);
    
        if (radioInput && !radioInput.checked) {
            radioInput.checked = true; // Update selection
    
            // Manually trigger the "change" event
            radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

    });

    // After registering the listener, mark it as set
    document.hasVariantChangeListener = true;
  }

  handleVariantChanged(variantName) {
    document.customProductEventLoggingEnabled && console.log(`Handling variant change: ${variantName}`);
    handleVariantChanged(variantName); // Calls the modularized function
  }
}

// Define the custom element
customElements.define('product-variant-selector', ProductVariantSelector);


// Function to handle variant change events
function handleVariantChanged(variantName, updateImage = true) {
    document.customProductEventLoggingEnabled && console.log("Variant Name:", variantName);

    if (updateImage) {
        triggerSlideEvent(variantName);
    }

    const variantDetails = getVariantDetails(variantName);
    document.customProductEventLoggingEnabled && console.log("Variant Details:", variantDetails);

    triggerProductTitleChange(variantDetails['variant_title']);
    triggerProductPriceChange(variantDetails['compare_at_price'], variantDetails['price']);
    triggerProductVariantChange(variantDetails['variant_id']);
    triggerProductVariantNameChange(variantName);
}

function triggerSlideEvent(variantName) {
    let indexToSlide = -1;

    switch (variantName) {
        case "Fair": indexToSlide = 3; break;
        case "Medium": indexToSlide = 0; break;
        case "Tan": indexToSlide = 6; break;
        case "Deep": indexToSlide = 9; break;
        default: console.warn("No matching variant for:", variantName); return;
    }

    document.customProductEventLoggingEnabled && console.log("Dispatching swipetoSlide event with index:", indexToSlide);
    document.dispatchEvent(new CustomEvent('swipetoSlide', { detail: { index: indexToSlide } }));
}

function triggerProductTitleChange(newTitle) {
    document.customProductEventLoggingEnabled && console.log("Dispatching product_title_changed event with new title:", newTitle);
    document.dispatchEvent(new CustomEvent('product_title_changed', { detail: { newTitle } }));
}

function triggerProductPriceChange(compareAtPrice, price) {
    document.customProductEventLoggingEnabled && console.log("Dispatching product_price_changed event with Compare At Price:", compareAtPrice, "Price:", price);
    document.dispatchEvent(new CustomEvent('product_price_changed', { detail: { compare_at_price: compareAtPrice, price } }));
}

function triggerProductVariantChange(variantId) {
    document.customProductEventLoggingEnabled && console.log("Dispatching product_variant_changed event with variant ID:", variantId);
    document.dispatchEvent(new CustomEvent('product_variant_changed', { detail: { variant_id: variantId } }));
}

function triggerProductVariantNameChange(variantName) {
    document.customProductEventLoggingEnabled && console.log("Dispatching product_variant_name_changed event with variant name:", variantName);
    document.dispatchEvent(new CustomEvent('product_variant_name_changed', { detail: { variantName } }));
}

class ProductVariantLabel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.variantLabel = this.querySelector('[data-product-variant-visible-name] span');

    if (!this.variantLabel) {
      console.warn("No element found with [data-product-variant-visible-name] attribute inside <product-variant-label>");
      return;
    }

    document.addEventListener('product_variant_name_changed', (event) => {
      const { variantName } = event.detail;

      document.customProductEventLoggingEnabled && console.log(`product_variant_name_changed event received: New Variant Name ->`, variantName);
      this.variantLabel.textContent = variantName;
      document.customProductEventLoggingEnabled && console.log(`Updated variant visible name: ${variantName}`);
    });
  }
}

// Define the custom element
customElements.define('product-variant-label', ProductVariantLabel);


function waitForVariantChangeListenerAndDispatchDefaultVariant(retries = 10, delay = 100) {
    // Check if the default variant is set
    if (typeof window.defaultVariant === "undefined") {
        if (retries > 0) {
            document.customProductEventLoggingEnabled && console.log(`defaultVariant not found, retrying in ${delay}ms...`);
            setTimeout(() => waitForVariantChangeListenerAndDispatchDefaultVariant(retries - 1, delay), delay);
        } else {
            console.error("defaultVariant is undefined. Event not dispatched.");
        }
        return;
    }

    // Check if the listener exists
    if (document.hasVariantChangeListener) {
        document.customProductEventLoggingEnabled && console.log(`Dispatching variant_changed for '${window.defaultVariant}'`);
        document.dispatchEvent(new CustomEvent("variant_changed", { detail: { variantName: window.defaultVariant } }));
        return;
    }

    if (retries > 0) {
        document.customProductEventLoggingEnabled && console.log(`Listener not found, retrying in ${delay}ms...`);
        setTimeout(() => waitForVariantChangeListenerAndDispatchDefaultVariant(retries - 1, delay), delay);
    } else {
        console.error("Failed to find a variant listener, event not dispatched.");
    }
}

// Correctly handle dispatch in case page is cached and page show event triggers. Also, make sure we set autocomplete off in radio 
// button, so browser does not cache last checked value of radio button.

// Track whether we've already dispatched the default variant
let hasDispatchedDefaultVariant = false;

// Ensure the document is fully loaded before checking for listeners & defaultVariant
document.addEventListener("DOMContentLoaded", () => {
    console.log("Dispatching default variant on DOMContentLoaded");
    waitForVariantChangeListenerAndDispatchDefaultVariant();
    hasDispatchedDefaultVariant = true; // Mark as executed
});

// Restore correct selection after BFCache restore
document.addEventListener("pageshow", (event) => {
    if (event.persisted && !hasDispatchedDefaultVariant) {
        console.log("Page restored from BFCache. Reapplying default variant.");
        requestAnimationFrame(() => {
            waitForVariantChangeListenerAndDispatchDefaultVariant();
        });
        hasDispatchedDefaultVariant = true; // Ensure it runs only once
    }
});
document.addEventListener("DOMContentLoaded", function(event) {
    let hardcodedDiscountCode = "LEC20"; // Hardcoded discount code
    let should_validate_discount = false;
    
    document.querySelectorAll("form[action*='/cart/add']").forEach(form => {
        form.addEventListener("submit", async function(e) {
            e.preventDefault(); // Intercept the default Shopify "Add to Cart" request
          
            const submitButton = form.querySelector('[type="submit"]');
            submitButton.classList.add('loading');
          
            let formData = new FormData(form);
            let productData = Object.fromEntries(formData.entries());
    
            try {                
                // Apply the discount code with validation before adding the item to cart
                 await applyDiscountCode(hardcodedDiscountCode, should_validate_discount);
    
                // Proceed to add the item to the cart and redirect
                const add_to_cart_response = await addToCartAndRedirect(productData, submitButton);    
            } catch (error) {
                console.error("Error in adding item to cart:", error);
              submitButton.classList.remove('loading');
            } finally {
                // submitButton.classList.remove('loading');
            }
        });
    });

async function addToCartAndRedirect(productData, submitButton) {
  // Construct the payload with all the variants
  const variantQueue = [
    {
      id: 40192039911479, // Sample Microdermabrasion Scrub
      quantity: 1,
      title: 'Sample Microdermabrasion Scrub'
    },
    {
      id: 40192040009783, // Sample Makeup Primer
      quantity: 1,
      title: 'Sample Makeup Primer'
    },
    {
      id: 40192040108087, // Sample Barrier Repair Mask
      quantity: 1,
      title: 'Sample Barrier Repair Mask'
    },
    {
      id: productData.id,
      quantity: productData.quantity || 1,
      title: productData.title
    }
  ];

  // Shopify expects the payload in this format
  const payload = {
    items: variantQueue.map(({ id, quantity }) => ({
      id,
      quantity
    }))
  };

  try {
    // ✅ Make a single API call to add all items to the cart
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const error = await response.json();
      console.warn(`❌ Failed to add items to the cart:`, error);
      throw new Error(`Add to cart failed`);
    }

    const data = await response.json();
    console.log("✅ All products added successfully:", data);

    // ✅ Dispatch the event to update the cart
    window.dispatchEvent(new CustomEvent('cart-updated'));
    
    // ✅ Now, trigger the cart to open
    window.dispatchEvent(new CustomEvent('toggle-cart', { detail: { open: true }}));

    // ✅ Remove loading state from the button
    submitButton.classList.remove('loading');
  } catch (error) {
    console.error("❌ Error adding to cart:", error);
    throw error;
  }
}


// async function addToCartAndRedirect(productData, submitButton) {
//   const variantQueue = [
//     {
//       id: 40192039911479, // Sample Microdermabrasion Scrub
//       quantity: 1,
//       title: 'Sample Microdermabrasion Scrub'
//     },
//     {
//       id: 40192040009783, // Sample Makeup Primer
//       quantity: 1,
//       title: 'Sample Makeup Primer'
//     },
//     {
//       id: 40192040108087, // Sample Barrier Repair Mask
//       quantity: 1,
//       title: 'Sample Barrier Repair Mask'
//     },
//     {
//       id: productData.id,
//       quantity: productData.quantity || 1,
//       title: productData.title
//     }
//   ];

//   try {
//     for (const item of variantQueue) {
//       const response = await fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(item)
//       });
//       console.log("WWAI Adding product:", item.title, item.id, item.quantity);
//       if (!response.ok) {
//         const error = await response.json();
//         console.warn(`❌ Failed to add variant ${item.id}:`, error);
//         throw new Error(`Add to cart failed for variant ${item.id}`);
//       }
//     }

//     // ✅ All items added, now redirect
//     // window.location.href = "/cart";
//     // window.dispatchEvent(new CustomEvent('toggle-cart', { detail: { open: true }}));

//     // First, dispatch the event to update the cart
//     window.dispatchEvent(new CustomEvent('cart-updated'));
//     // Now, trigger the cart to open
//     window.dispatchEvent(new CustomEvent('toggle-cart', { detail: { open: true }}));

    
//     submitButton.classList.remove('loading');
//   } catch (error) {
//     console.error("Error adding to cart:", error);
//     throw error;
//   }
// }


  async function validateDiscountCode(code) {
    try {
        const shopify_features_script = document.querySelector("script[id='shopify-features']");
        const shopify_features_json = JSON.parse(shopify_features_script.innerHTML);
        const cart = await fetch(`${Shopify.routes.root}cart.js`).then(response => response.json());
  
        const headers = {
            Authorization: 'Basic ' + btoa(shopify_features_json.accessToken),
            Accept: '*/*',
            'Content-Type': 'application/json',
        };
  
        const body = {
            checkout: {
                line_items: cart.items,
                discount_code: code,
                country: Shopify.country,
                presentment_currency: cart.currency,
            },
        };
  
        const response = await fetch('/wallets/checkouts/', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            referrerPolicy: 'no-referrer',
        });
  
        const data = await response.json();
  
        if (data.errors && data.errors.discount_code) {
            return { isValid: false, error: data.errors.discount_code[0].message };
        }
  
        return { isValid: true };
    } catch (error) {
        console.error("Error in validateDiscountCode:", error);
        return { isValid: false, error: "Unable to validate discount code" };
    }
  }

  async function activateDiscountUsingDiscountEndpoint(code) {
      try {
          const response = await fetch(`/discount/${code}`);
          const html = await response.text();
          return { success: true, html: html };
      } catch (error) {
          console.error("Discount activation failed (/discount):", error);
          return { success: false, error: "Unable to activate discount" };
      }
  }

  async function applyDiscountCode(code, should_validate = true) {
    try {
        // Step 1: Validate the discount code if required
        if (should_validate) {
            const validationResult = await validateDiscountCode(code);
            if (!validationResult.isValid) {
                console.error(`Failed to activate discount code "${code}" because: ${validationResult.error}`);
                return;
            }
        }
    
        // Step 2: Apply the discount code
        const activationResult = await activateDiscountUsingDiscountEndpoint(code);
    
        if (activationResult.success) {
            console.log(`Discount code "${code}" activated successfully.`);
        } else {
            console.error(`Failed to activate discount code "${code}" because: ${activationResult.error}`);
        }
    
    } catch (error) {
        console.error(`Error activating discount code "${code}":`, error);
    }
  }
});
